module.exports = __webpack_public_path__ + "media/images/flags/4x3/cub-0a499324f6909928abf51a997fa87d41.svg";